import '../style.scss';

import Text from './Text';

const Password = (params: any) => <Text type="password" {...params} />;

export default Password;
